import styled, { css } from 'styled-components';
import { margin, marginBottom } from '../v2/foundation/spacing/utils.js';
import { themeGet } from '../v2/foundation/theme/themeGet/get.js';
import { fontWeight } from '../theme/typography/fontWeight.js';
import { fontSize } from '../theme/typography/fontSize.js';

var baseStyles = css(["", ";font-style:normal;color:", ";text-align:", ";"], margin(0), themeGet('colors.gray.800'), function (props) {
  return props.$textAlign;
});
var shouldDiscardMargin = function shouldDiscardMargin(props) {
  return props.$noMargin;
};
var SubtitleContainer = styled.div.withConfig({
  displayName: "SubtitleContainer",
  componentId: "sc-9xbkid-0"
})(["", ";color:", ";font-style:normal;text-align:", ";"], fontWeight('normal'), themeGet('colors.gray.700'), function (props) {
  return props.$textAlign;
});
var mainStyles = css(["", ";", ";", ";", ";& + ", "{", ";", ";}"], baseStyles, fontWeight('semibold'), fontSize('xLarge', 1.5), function (props) {
  return marginBottom(shouldDiscardMargin(props) ? 0 : 4);
}, SubtitleContainer, function (props) {
  return marginBottom(props.$noMargin ? 0 : 4);
}, fontSize('base', 1.5));
var pageStyles = css(["", ";", ";", ";", ";& + ", "{", ";", ";}"], baseStyles, fontWeight('normal'), fontSize('large', 1.3), function (props) {
  return marginBottom(shouldDiscardMargin(props) ? 0 : 4);
}, SubtitleContainer, function (props) {
  return marginBottom(props.$noMargin ? 0 : 4);
}, fontSize('base', 1.5));
var sectionStyles = css(["", ";", ";", ";", ";& + ", "{", ";", ";}"], baseStyles, fontWeight('semibold'), fontSize('infrequent', 1.5), function (props) {
  return marginBottom(shouldDiscardMargin(props) ? 0 : 3);
}, SubtitleContainer, function (props) {
  return marginBottom(props.$noMargin ? 0 : 3);
}, fontSize('base', 1.5));
var subsectionStyles = css(["", ";", ";", ";", ";& + ", "{", ";", ";}"], baseStyles, fontWeight('semibold'), fontSize('base', 1.5), function (props) {
  return marginBottom(shouldDiscardMargin(props) ? 0 : 3);
}, SubtitleContainer, function (props) {
  return marginBottom(props.$noMargin ? 0 : 3);
}, fontSize('small', 1.5));
var labelStyles = css(["", ";", ";", ";", ";& + ", "{", ";", ";}"], baseStyles, fontWeight('semibold'), fontSize('small', 1.5), function (props) {
  return marginBottom(shouldDiscardMargin(props) ? 0 : 2);
}, SubtitleContainer, function (props) {
  return marginBottom(props.$noMargin ? 0 : 2);
}, fontSize('tiny', 1.5));
var TitleContainer = styled.div.withConfig({
  displayName: "TitleContainer",
  componentId: "sc-9xbkid-1"
})(["", ";", ";", ";", ";", ";"], function (props) {
  return props.$appearance === 'main' && mainStyles;
}, function (props) {
  return props.$appearance === 'page' && pageStyles;
}, function (props) {
  return props.$appearance === 'section' && sectionStyles;
}, function (props) {
  return props.$appearance === 'subsection' && subsectionStyles;
}, function (props) {
  return props.$appearance === 'label' && labelStyles;
});

export { SubtitleContainer, TitleContainer, labelStyles, mainStyles, pageStyles, sectionStyles, subsectionStyles };
